import styled, { css } from 'styled-components';
import { colors } from 'global/colors';

export const SelectTest = styled.div.attrs({ className: 'row' })`
  margin: 0;
`;
export const PageActionContainer = styled.div`
  width: 100%;
  margin-bottom: -41px;
  @media (max-width: 991px) {
    margin-bottom: 0;
  }
`;
export const TestsList = styled.div.attrs({ className: 'col-lg-7 col-xl-7 col-md-12 col-xs-12' })`
  padding: 0 0 0.75rem 0;

  @media (max-width: 450px) {
    font-size: 12px;
  }
`;
export const SelectedTestsList = styled.div.attrs({ className: 'col-lg-5 col-xl-5 col-md-12 col-xs-12' })`
  margin-top: 41px;
  padding: 0 0 0.75rem 1rem;
  @media (max-width: 991px) {
    margin-top: 0;
    padding: 0 0 0.75rem 0;
  }
`;
export const SendTestButton = styled.button.attrs({ className: 'btn' })`
  color: ${colors.white};
  background-color: ${colors.darkBlue};
  border-color: ${colors.darkBlue};
  margin: 0;
  padding: 0.375rem 1rem;
  &:hover {
    color: ${colors.white};
    background: ${colors.hoverBlue};
    border-color: ${colors.hoverBlue};
  }
  &:focus {
    outline: 0 none !important;
    box-shadow: none;
  }
`;
export const SendTestButtonContainer = styled.div`
  padding-bottom: 20px;
  text-align: center;
`;

export const SelectedTestsTableContainer = styled.div`
  clear: both;
  background-color: ${colors.white};
  width: 100%;
  border: 1px solid ${colors.borderGray};
  border-radius: 0.25rem;
`;

export const SelectedTestButton = styled.a`
  cursor: pointer;
  background-color: ${colors.lightBlue6};
  color: ${colors.white};
  font-size: 12px;
  line-height: 2;
  text-align: center;
  float: right;
  height: 30px;
  padding: 2px 8px;
  margin-left: 5px;
  margin-bottom: 11px;
  user-select: none;
  border-radius: 0.2rem;
  border: 1px solid transparent;
  ${(props) =>
    props.width &&
    css`
      width: ${props.width};
    `}
  &:hover {
    background-color: ${colors.darkBlue};
    color: ${colors.white};
    text-decoration: none;
  }
`;

export const SelectTestTabContent = styled.div`
  clear: both;
  background-color: ${colors.white};
  ${(props) =>
    !props.autoHeight &&
    css`
      overflow-y: auto;
      max-height: 500px;
    `}
`;

export const SendTestPageWrapper = styled.div`
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  padding: 55px 15px 0 15px;
  @media (min-width: 576px) {
    max-width: 540px;
  }
  @media (min-width: 768px) {
    max-width: 720px;
  }
  @media (min-width: 992px) {
    max-width: 960px;
  }
  @media (min-width: 1200px) {
    max-width: 1140px;
  }
`;
export const DemoCompanyPurchaseSection = styled.div.attrs({ className: 'alert alert-warning' })`
  text-align: center;
`;
export const BuyTestLink = styled.a`
  &:hover {
    cursor: pointer;
    text-decoration: none;
  }
`;

export const SendTestFormContainer = styled.div`
  background-color: ${colors.white};
  margin-bottom: 0.75rem;
  border: 1px solid ${colors.borderGray};
  border-radius: 0.25rem;
  h5 {
    color: ${colors.darkBlue};
  }
`;

export const SendTestForm = styled.div`
  font-size: 14px;
  padding: 15px 15px 0 15px;
  max-width: 660px;
  margin: 0 auto;
  @media (min-width: 992px) {
    padding-top: 40px;
  }
`;

export const TableHeader = styled.div`
  padding: 0.75rem;
  font-size: 14px;
  font-weight: bold;
  display: inline-flex;
  justify-content: left;
  align-items: center;
  ${(props) =>
    css`
      width: ${props.widthPercentage ?? '50%'};
    `}
  ${(props) =>
    props.isClickable &&
    css`
      cursor: pointer;
    `}
  align-items: center;
  ${(props) =>
    props.mobileHide &&
    css`
      @media (max-width: 450px) {
        display: none;
      }
    `}
`;
export const TableRow = styled.div`
  border: 1px solid ${colors.borderGray};
  background-color: ${colors.white};
  &:nth-of-type(odd) {
    background-color: ${colors.lightBlue};
  }
  ${(props) =>
    props.locked &&
    css`
      opacity: 0.5;
      cursor: not-allowed;
      position: relative;
    `}
`;
export const TableCell = styled.div`
  font-weight: 400;
  display: inline-flex;
  justify-content: left;
  align-items: center;
  vertical-align: middle;
  font-size: 17px;
  color: #295c88;
  ${(props) =>
    !props.noPadding &&
    css`
      padding: 0.75rem;
    `}
  ${(props) =>
    props.paddingX &&
    css`
      padding-top: 0.75rem;
      padding-bottom: 0.75rem;
    `}
  ${(props) =>
    props.zeroPaddingLeft &&
    css`
      padding-left: 0;
    `}
  ${(props) =>
    css`
      width: ${props.widthPercentage ?? '50%'};
    `}
  ${(props) =>
    props.verticalTop &&
    css`
      align-items: start;
      vertical-align: top;
    `}
  @media (max-width: 450px) {
    font-size: 14px;
  }
`;
export const TableCellContent = styled.div`
  width: 47%;
  @media (max-width: 450px) {
    display: none;
  }
`;
export const TableActionButtonContainer = styled.div`
  ${(props) =>
    css`
      width: ${props.widthPercentage ?? '53%'};
    `}
  text-align: right;
  @media (max-width: 450px) {
    width: 100%;
  }
`;
export const TableActionButton = styled.button.attrs({ className: 'btn' })`
  background-color: ${(props) => (props.isSelected ? colors.green2 : colors.darkBlue)};
  color: ${colors.white};
  padding: 0.25rem 0.75rem;
  margin: 0;
  width: 120px;
  font-weight: 400;
  font-size: 0.875rem;
  &:hover {
    color: ${colors.white};
    background: ${(props) => (props.isSelected ? colors.hoverGreen : colors.hoverBlue)};
    border-color: ${(props) => (props.isSelected ? colors.hoverGreen : colors.hoverBlue)};
  }
  &:focus {
    outline: 0 none !important;
    box-shadow: none;
  }
`;
export const NoteContainer = styled.div`
  padding 12px;
  background-color:${colors.lightBlue};
`;
export const Note = styled.span`
  display: block;
  color: ${colors.darkGray};
  margin-bottom: 2px;
  ${(props) =>
    props.isClickable &&
    css`
      cursor: pointer;
    `}
  ${(props) =>
    css`
      font-size: ${props.fontSize ?? '11px'};
    `}
  & i {
    font-size: 14px;
  }
`;

export const Block = styled.div``;

export const ArrowUp = styled.i.attrs({ className: 'fa fa-caret-up' })`
  margin-left: 4px;
`;
export const ArrowDown = styled.i.attrs({ className: 'fa fa-caret-down' })`
  margin-left: 4px;
`;
export const InformationIcon = styled.i.attrs({ className: 'fa fa-info-circle' })`
  margin-left: 2px;
`;
export const XIcon = styled.i.attrs({ className: 'fa fa-times' })`
  color: ${colors.black};
  font-size: 14px;
  cursor: pointer;
  margin-left: 2px;
  ${(props) =>
    props.marginTop &&
    css`
      margin-top: 0.75rem;
    `}
`;
export const SendIcon = styled.i.attrs({ className: 'fa fa-send' })``;
export const PlusIcon = styled.i.attrs({ className: 'fa fa-plus' })``;
export const MinusIcon = styled.i.attrs({ className: 'fa fa-minus' })``;
export const QuestionIcon = styled.i.attrs({ className: 'fa fa-question' })``;
export const LockIcon = styled.i.attrs({ className: 'fa fa-lock' })`
  padding-left: 3px;
`;
export const CopyIcon = styled.i.attrs({ className: 'fa fa-copy' })`
  font-size: 1rem;
  width: 36px;
  line-height: 36px;
`;

export const Dropdown = styled.div`
  position: relative;
`;
export const DropdownButton = styled.button`
  background: ${colors.white};
  padding: 0.25rem 0.75rem;
  font-size: 0.875rem;
  line-height: 1.5;
  color: ${colors.darkBlue};
  border: 1px solid ${colors.lightGray};
  border-radius: 0.2rem;
  ${(props) =>
    css`
      width: ${props.widthSize ?? '100px'};
    `}
  &:disabled {
    cursor: not-allowed;
    opacity: 0.65;
  }
`;
export const DropdownButtonBlue = styled.button`
  background: ${colors.darkBlue};
  color: ${colors.white};
  padding: 0.375rem 1rem;
  font-size: 1rem;
  line-height: 1.5;
  border: 1px solid ${colors.darkBlue};
  border-radius: 0.2rem;
  &:hover {
    background: ${colors.hoverBlue};
    border-color: ${colors.hoverBlue};
  }
`;
export const LanguageDropdownButton = styled.button`
  padding-left: 11px;
  float: left;
  height: 38px;
  width: 100%;
  background: ${colors.white};
  color: ${colors.darkGray};
  border: 1px solid ${colors.lightGray};
  border-radius: 0.2rem;
`;
export const DropdownMenu = styled.div.attrs((props) => ({
  className: `dropdown-menu ${props.dropdownRight && 'dropdown-menu-right'}`,
}))`
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 10000;
  display: none;
  float: left;
  min-width: 160px;
  padding: 5px 0;
  margin: 2px 0 0;
  font-size: 1rem;
  color: #373a3c;
  text-align: left;
  list-style: none;
  background-color: #fff;
  -webkit-background-clip: padding-box;
  background-clip: padding-box;
  border: 1px solid #00000026;
  border-radius: 0.25rem;
  box-shadow: 0 6px 12px #0000002e;
  & span {
    padding: 3px 20px;
  }
`;
export const CandidatesDropdownMenu = styled.div.attrs({ className: 'dropdown-menu' })`
  max-height: 300px;
  overflow-y: scroll;
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  display: none;
  float: left;
  min-width: 160px;
  padding: 5px 0;
  margin: 2px 0 0;
  font-size: 1rem;
  color: #373a3c;
  text-align: left;
  list-style: none;
  background-color: #fff;
  -webkit-background-clip: padding-box;
  background-clip: padding-box;
  border: 1px solid #00000026;
  border-radius: 0.25rem;
  box-shadow: 0 6px 12px #0000002e;
  & span {
    padding: 3px 20px;
  }
`;
export const LanguageDropdownMenu = styled.div.attrs({ className: 'dropdown-menu' })`
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  display: none;
  float: left;
  min-width: 160px;
  padding: 5px 0;
  margin: 2px 0 0;
  font-size: 1rem;
  color: #373a3c;
  text-align: left;
  list-style: none;
  background-color: #fff;
  -webkit-background-clip: padding-box;
  background-clip: padding-box;
  border: 1px solid #00000026;
  border-radius: 0.25rem;
  box-shadow: 0 6px 12px #0000002e;
  & span {
    padding: 3px 20px;
  }
  @media (max-width: 575px) {
    width: 100%;
  }
`;
export const DropdownItem = styled.div`
  display: block;
  width: 100%;
  padding: 3px 20px;
  ${(props) =>
    props.noPadding &&
    css`
      padding: 0 0;
    `}
  clear: both;
  font-size: 14px;
  font-weight: normal;
  line-height: 1.5;
  color: ${(props) => (props.selected ? colors.darkBlue : colors.darkGray)};
  text-align: inherit;
  white-space: nowrap;
  background: none;
  border: 0;
  cursor: pointer;
  &:hover {
    background-color: ${colors.lightGray};
  }
`;

export const CustomTimeLimit = styled.input.attrs({ type: 'number', min: '5', max: '1000', step: '5' })`
  width: 3em;
  background: transparent;
  border: 0;
  padding: 0;
  margin: 0;
  font-size: 14px;
  color: ${colors.darkBlue};
  &:focus {
    outline: 0 none !important;
  }
`;

export const Divider = styled.div`
  height: 1px;
  margin: 0.5rem 0;
  overflow: hidden;
  background-color: ${colors.lightGray};
`;

export const FormSection = styled.section`
  padding: 20px 0;
`;
export const FormHeader = styled.h5``;
export const CandidateListRow = styled.div`
  margin: 0 -0.75rem;
  display: flex;
  justify-content: space-between;
  vertical-align: top;
`;
export const AddCandidateButton = styled.div`
  padding: 0.25rem 0.75rem;
  margin-bottom: 10px;
  cursor: pointer;
`;
export const RemoveAllCandidateButton = styled.div`
  padding: 0.25rem 0.75rem;
  margin-bottom: 10px;
  cursor: pointer;
`;
export const ExcelFileUploaderContainer = styled.div``;
export const FileUploaderLabel = styled.label``;
export const FileUploaderInput = styled.input.attrs({ type: 'file', accept: '.xls, .xlsx' })``;
export const TextInput = styled.input.attrs({ className: 'form-control' })``;

export const CheckboxContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

export const CheckboxLabel = styled.span`
  cursor: pointer;
  color: #373a3c;
  font-weight: 400;
  margin-left: 8px;
  margin-bottom: 0px;
  font-size: 15px;
  display: flex;
`;

export const ReminderDaysInput = styled.input.attrs({ type: 'number', min: '0', className: 'form-control' })`
  width: 4em;
  border: 1px solid #e5e5e5;
  padding: 2px 0px 2px 4px;
  margin: 0 5px;
  display: inherit;
  height: 30px;
`;

export const RowContainer = styled.div.attrs({ className: 'row' })`
  margin: 0 0 1rem 0;
`;
export const LanguageDropdownContainer = styled.div.attrs({ className: 'col-sm-3 col-xs-12' })`
  padding: 0;
`;
export const EmailSubjectInputContainer = styled.div.attrs({ className: 'col-sm-9 col-xs-12' })`
  padding: 0 0 0 1rem;
  @media (max-width: 575px) {
    padding: 1rem 0 0 0;
  }
`;
export const EmailSubjectInput = styled.input.attrs({ className: 'form-control' })``;

export const LanguageFlag = styled.img`
  height: 15px;
  width: 18px;
  margin-right: 10px;
  margin-bottom: 3px;
`;

export const NewBadge = styled.span`
  vertical-align: middle;
  text-align: center;
  line-height: 18px;
  height: 18px;
  width: 40px;
  position: relative;
  bottom: 10px;
  left: 5px;
  font-size: 11px !important;
  color: white !important;
  font-weight: bold;
  text-transform: uppercase;
  background-color: #7ec666;
  border-radius: 2px;
  ${(props) =>
    props.hasPadding &&
    css`
      padding: 1px 3px;
    `}

  @media (max-width: 450px) {
    font-size: 9px !important;
    bottom: 7px;
  }
  @media (max-width: 370px) {
    display: none;
  }
`;

export const InputContainer = styled.div`
  width: 100%;
`;
export const ErrorMessage = styled.p`
  color: ${colors.red};
  ${(props) =>
    props.small &&
    css`
      font-size: 12px;
    `}
  ${(props) =>
    props.noMarginBottom &&
    css`
      margin-bottom: 0;
    `}
`;
export const ModalContentContainer = styled.div`
  overflow-y: auto;
  font-size: 14px;
  color: #373a3c;
  font-weight: 400;
  width: 100%;
  padding-right: 5px;
  & img {
    max-width: 100%;
  }
`;
export const ModalContentTitle = styled.span`
  font-weight: bold;
`;

export const TicketModalDescription = styled.p`
  font-size: 1rem;
`;
export const TicketContainer = styled.div`
  margin-bottom: 1rem;
`;
export const TicketModalSpan = styled.span``;
export const TicketLink = styled.input.attrs({ className: 'form-control' })`
  background-color: ${colors.lightGray};
  width: 91%;
  display: inline-block;
  &:focus {
    outline: 0 none !important;
    border-color: #e5e5e5;
  }
`;

export const CopyLinkButton = styled.a`
  cursor: pointer;
  background-color: ${colors.darkBlue};
  color: ${colors.white};
  text-align: center;
  display: inline-block;
  margin-left: 5px;
  height: 38px;
  user-select: none;
  border-radius: 0.2rem;
  border: 1px solid transparent;
  ${(props) =>
    props.width &&
    css`
      width: ${props.width};
    `}
  &:hover {
    background-color: ${colors.hoverBlue};
    color: ${colors.white};
    text-decoration: none;
  }
`;
